import { createSlice } from "@reduxjs/toolkit";
import { factory } from "../../api/apiFactory";
import { showNotification } from "./notificationSlice";

const compnayTreeApi = factory.get("compnay_tree");

const initialState = {
  company_tree: {
    nodes: [],
    departments: [],
    loading: false,
  },
  update_loading: false,
};

export const companyTreeSlice = createSlice({
  name: "companyTree",
  initialState,
  reducers: {
    setLoading(state, action) {
      state.company_tree.loading = action.payload;
    },
    setUpdateLoading(state, { payload }) {
      state.update_loading = payload;
    },
    setCompanyTree(state, { payload }) {
      state.company_tree.nodes = payload;
      state.company_tree.loading = false;
    },
  },
});

export const {
  setLoading,
  setCompanyTree,
  updateNodePosition,
  setUpdateLoading,
} = companyTreeSlice.actions;
export default companyTreeSlice.reducer;

export const getTree = () => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const res = await compnayTreeApi.getTree();
    const data = res.data.data || res.data || res;
    dispatch(setCompanyTree(data));
  } catch (err) {
    dispatch(setLoading(false));
    dispatch(
      showNotification({ message: err.response.data.errors[0], type: "error" }),
    );
  }
};

export const updateEmployeeDetails = (id, payload) => async (dispatch) => {
  try {
    dispatch(setUpdateLoading(true));
    const res = await compnayTreeApi.change(id, payload);
    dispatch(getTree());
    dispatch(setUpdateLoading(false));

    dispatch(
      showNotification({ message: "تم التحديث بنجاح", type: "success" }),
    );

    return Promise.resolve(res);
  } catch (err) {
    dispatch(setUpdateLoading(false));
    return Promise.reject(err);
  }
};

export const deleteEmployee = (id) => async (dispatch) => {
  try {
    dispatch(setUpdateLoading(true));
    const res = await compnayTreeApi.deleteEmp(id);
    dispatch(setUpdateLoading(false));
    dispatch(showNotification({ message: "تم الحذف بنجاح", type: "success" }));
    return Promise.resolve(res);
  } catch (err) {
    dispatch(setUpdateLoading(false));
    return Promise.reject(err);
  }
};
export const CompanyTree = { getTree, updateEmployeeDetails, deleteEmployee };
